import React, {useEffect, useRef} from "react";
import {mount, reinitialize, unmount} from "booking-engine-widget/src";
import {Box} from "@mui/material";


const PUBLIC_KEY = String(process.env.REACT_APP_PUBLIC_KEY)

interface Props {
    widgetId: string
    agendaId?: string
    selectedServiceId?: string
    initialStartTime?: Date
    onCompletedCallback: () => void
    selectedSectorId?: string
}

declare global {
    interface Window {
        bookingWidget: {
            mount: typeof mount;
            unmount: typeof unmount;
            reinitialize: typeof reinitialize;
        };
    }
}
const AgendaEventDialogPreview = ({
                                      widgetId,
                                      agendaId,
                                      selectedServiceId,
                                      initialStartTime,
                                      onCompletedCallback,
                                      selectedSectorId,
                                  }: Props) => {


    useEffect(() => {
        window.bookingWidget?.mount(
            {
                position: "relative",
                maxWidth: "100%",
                showHeading: false,
                agendaId,
                selectedServiceId,
                initialStartTime,
                onCompletedCallback,
                selectedSectorId
            }
        );
        return () => window.bookingWidget?.unmount();

    }, []);

    const holderRef = useRef(null);


    return <Box sx={{p: 3, width: "100%"}}>
        {
            //@ts-ignore
            <div widget_id={widgetId}
                 className={'crqlar-booking-widget'}
                 public_key={PUBLIC_KEY}
                 ref={holderRef}
            />
        }
    </Box>

}

export default AgendaEventDialogPreview;
